import React, { useEffect, useCallback } from 'react';
import styles from './WorkPopup.module.css';
import PopupContent from './PopupContent';

const WorkPopup = ({ work, onClose }) => {
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [handleEscape]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={onClose}>
          <span className={styles.closeIcon}></span>
        </button>
        <PopupContent work={work} />
      </div>
    </div>
  );
};

export default WorkPopup;